import { useState, useEffect } from "react";
import { showError, showSuccess } from "../util/toast";

/**
 * Hook para detectar status de conexão offline/online
 * @returns {boolean} - true se estiver offline, false se estiver online
 */
export const useOffline = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      showSuccess("Conexão restaurada!", { duration: 2000 });
    };

    const handleOffline = () => {
      setIsOffline(true);
      showError("Você está offline. Algumas funcionalidades podem não estar disponíveis.", {
        duration: 5000,
      });
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOffline;
};

